// extracted by mini-css-extract-plugin
export default {"title":"title_title__1LAVc","titleEditWrapper":"title_titleEditWrapper__-717I","editable":"title_editable__cyOMY","editing":"title_editing__pLB02"};